// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3ddTD","ranges":"BmiRanges_ranges__2OaQW"};